import React from 'react';

const JS_Website = () => {
  return (
    <div >
      <h1>JS_Website</h1>
      <p>Placeholder component for: "JS Website"</p>
    </div>
  );
};

export default JS_Website;
